<template>
    <div class="plan-stack-skeleton plans-bar-stack" aria-busy="true" aria-label="Loading plans">
        <div v-for="n in 2" :key="n" class="plans-bar-stack__item">
            <div class="ac-floating-panel">
                <div class="ac-panel-content ac-white-panel skel-panel-inner">
                    <div class="skel-header-row">
                        <div class="skeleton-line skel-shimmer w-40"></div>
                        <div class="skeleton-line skel-shimmer w-28"></div>
                    </div>
                    <div class="skeleton-line skel-shimmer w-100 mt-3"></div>
                    <div class="skeleton-line skel-shimmer w-92 mt-2"></div>
                    <div class="skeleton-line skel-shimmer w-88 mt-2"></div>
                    <div class="skel-rows mt-3">
                        <div v-for="r in 3" :key="r" class="skel-plan-row">
                            <div class="skeleton-line skel-shimmer w-30"></div>
                            <div class="skeleton-line skel-shimmer w-18"></div>
                            <div class="skeleton-pill skel-shimmer"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PlanStackSkeleton",
};
</script>

<style scoped>
.plans-bar-stack {
    display: flex;
    flex-direction: column;
    gap: 1.75rem;
}

.plans-bar-stack__item {
    min-width: 0;
}

.ac-floating-panel {
    margin-bottom: 10px;
}

.ac-panel-content {
    padding: 20px;
    box-shadow: 0 1px 4px rgb(0 0 0 / 20%);
}

.ac-white-panel {
    background-color: white;
    border-radius: 10px;
}

.skel-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}

.skeleton-line {
    height: 16px;
    border-radius: 6px;
}

.skel-plan-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
}

.skeleton-pill {
    width: 100px;
    height: 32px;
    border-radius: 6px;
    margin-left: auto;
}

.w-18 {
    width: 18%;
    min-width: 56px;
}

.w-28 {
    width: 28%;
    min-width: 72px;
}

.w-30 {
    width: 30%;
}

.w-40 {
    width: 40%;
}

.w-88 {
    width: 88%;
}

.w-92 {
    width: 92%;
}

.w-100 {
    width: 100%;
}

.mt-2 {
    margin-top: 8px;
}

.mt-3 {
    margin-top: 12px;
}

.skel-shimmer {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 1000px 104px;
}

@keyframes placeHolderShimmer {
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
}
</style>
